'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import Phone from '@hc-frontend/core-icons/kit/phone';
import type { PhoneCampaign } from '@hc-frontend/core-types';
import { Link, Tooltip, TTYList } from '@hc-frontend/core-ui';
import Image from 'next/image';

import { CallCta } from '../../atoms/call-cta';

export function CallCampaignPhoneAndScheduleWithIcon({
  phoneCampaign,
  placement,
  category,
  label,
  iconUrl,
  sameSize,
}: {
  phoneCampaign: PhoneCampaign;
  placement?: string;
  category?: string;
  label?: string;
  iconUrl?: string;
  sameSize?: boolean;
}) {
  if (!iconUrl) {
    const config = getClientApplicationConfig();
    iconUrl = `${config.assets.marketplaceStaticBaseUrl}/marketplace/images/typ/agent.png`;
  }

  return (
    <>
      <div className="tablet:hidden">
        <CallCta
          phoneCampaign={phoneCampaign}
          placement={placement}
          category={category}
          label={label}
          className="hc-typography--heading-three block tablet:max-w-[45px]"
        >
          <Phone data-testid="call-cta-phone" />
        </CallCta>
      </div>
      <div className="hidden gap-4-4 tablet:flex">
        <Image
          src={iconUrl}
          alt="agent"
          width={46}
          height={46}
          priority
          style={{
            objectFit: 'contain',
            minWidth: 46,
            minHeight: 46,
          }}
        />
        <div
          className="hc-stack-layout--small flex"
          style={{
            '--hc-stack-layout-space-small': '0rem',
          }}
        >
          <p
            className={
              sameSize
                ? 'hc-typography--paragraph-sm'
                : 'hc-typography--disclaimer font-bold'
            }
          >
            Have a specific question? Ask a licensed agent:
          </p>
          <div className="flex">
            <Link
              href={phoneCampaign.href}
              className={
                'hc-btn--text p-[0] font-semibold leading-[calc(var(--font-size-heading-three)*0.85)] focus:no-underline ' +
                (sameSize
                  ? 'hc-typography--paragraph-sm'
                  : 'hc-typography--heading-three')
              }
              id="call_now_link"
              placement={placement}
              category={category}
              label={label}
              data-call-call-type={phoneCampaign.callType}
              data-call-placement={phoneCampaign.placement}
              data-call-product={
                phoneCampaign.subProduct || phoneCampaign.product
              }
              data-call-phone={phoneCampaign.href}
              data-call-advertiser={phoneCampaign.advertiser}
            >
              {phoneCampaign.phoneNumber}
            </Link>
          </div>
          <div
            className={
              'inline-flex gap-2-4 ' +
              (sameSize
                ? 'hc-typography--paragraph-sm'
                : 'hc-typography--disclaimer')
            }
          >
            <div className="inline-block max-w-[35ch] overflow-hidden whitespace-nowrap text-gray-400">
              {phoneCampaign.todayTTY}
            </div>

            <Tooltip
              title={<TTYList items={phoneCampaign.weekTTY.split('|')} />}
              className="right-0 z-30 border-gray-400 bg-tertiary-50 !text-gray-950"
            >
              <span
                className={
                  'cursor-pointer text-nowrap font-bold text-tertiary-900 ' +
                  (sameSize
                    ? 'hc-typography--paragraph-sm'
                    : 'hc-typography--disclaimer')
                }
              >
                See Schedule
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
}
